import { __assign, __extends } from "tslib";
import { namespacedClassnames } from '../../../common/namespace-classes';
import * as React from 'react';
import { ReactSelectAsync, ReactSelect3, ReactSelect3Components } from '../../../common/react-select';
import { LibColor } from '../../../new-libby/core/colors/colors-map';
import { menuFooterStyle, selectV3Styles } from '../select-v3-styles';
import { Tooltip } from '../..';
import { getChevronIcon } from '../chevron-icon';
var defaultProps = {
    disabled: false,
    searchable: true,
    openOnFocus: true,
    clearable: false,
    autosize: false
};
var defaultV3Props = {
    disabled: false,
    searchable: true,
    openMenuOnFocus: true,
    clearable: false,
    autosize: false
};
/** @deprecated use <Select/> */
var DeprecatedSelect = /** @class */ (function (_super) {
    __extends(DeprecatedSelect, _super);
    function DeprecatedSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            query: ''
        };
        _this.refSelectV3 = React.createRef();
        _this.fakeLoadOptions = function (_, cb) {
            cb(null, { options: _this.props.options });
        };
        _this.formatOptionLabel = function (data, context) {
            if (context.context === 'menu') {
                return _this.props.optionRenderer ? _this.props.optionRenderer(data) : data.label;
            }
            else {
                return _this.props.valueRenderer ? _this.props.valueRenderer(data) : data.label;
            }
        };
        _this.optionRenderer = function (option) {
            var _a;
            var isSelected = option.value === ((_a = _this.props.value) === null || _a === void 0 ? void 0 : _a.value);
            return _this.props.optionRenderer ? _this.props.optionRenderer(option, { isSelected: isSelected }) : option.label;
        };
        // avoids blowup when onInputChange passed as async - https://app.asana.com/0/1198918337991486/1199694602056889/f
        _this.onInputChange = function (term) {
            _this.setState({ query: term });
            if (_this.props.onInputChange) {
                _this.props.onInputChange(term);
            }
        };
        // avoids the Menu from opening again because clicking on the Footer is still considered a focus event
        _this.onClickFooter = function (e) {
            var _a, _b;
            var footerCompClass = (_a = e.target) === null || _a === void 0 ? void 0 : _a.classList.value;
            if (_this.refSelectV3) {
                // checks if footer comp is a link
                if (!(footerCompClass === null || footerCompClass === void 0 ? void 0 : footerCompClass.includes('aul link'))) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                (_b = _this.refSelectV3.current) === null || _b === void 0 ? void 0 : _b.blur();
            }
        };
        _this.renderMenuFooter = function (menuProps) {
            if (_this.props.menuFooter) {
                var isMenuPlacementTop = menuProps.menuPlacement === 'top' ? true : false;
                var menuFooterComp = (React.createElement("div", { className: 'select-menu-footer', style: menuFooterStyle(isMenuPlacementTop), onClick: _this.onClickFooter }, _this.props.menuFooter));
                return isMenuPlacementTop ? (React.createElement(React.Fragment, null,
                    menuFooterComp,
                    menuProps.children)) : (React.createElement(React.Fragment, null,
                    menuProps.children,
                    menuFooterComp));
            }
            else {
                return menuProps.children;
            }
        };
        _this.renderV3 = function () {
            var _a;
            var props = _this.props;
            var valueV3 = ((_a = props.value) === null || _a === void 0 ? void 0 : _a.value) !== undefined ?
                props.value : props.options.find(function (option) { return option.value === props.value; });
            var optionsV3 = props.options.map(function (o) { return o.disabled ? __assign(__assign({}, o), { isDisabled: o.disabled }) : o; });
            var Menu = function (menuProps) {
                return (React.createElement(ReactSelect3Components.Menu, __assign({}, menuProps), _this.renderMenuFooter(menuProps)));
            };
            var DropdownIndicator = function (dropdownProps) {
                return (React.createElement(ReactSelect3Components.DropdownIndicator, __assign({}, dropdownProps), getChevronIcon(!!props.disabled)));
            };
            var IndicatorSeparator = function (_) { return null; };
            var NoOptionsMessage = function () {
                var noOptionStyle = { fontSize: '14px', fontWeight: 300, padding: '6px 12px', color: "" + LibColor.grey100 };
                var noOptionsElem = typeof props.noOptionsMessage === 'string' ?
                    React.createElement("div", { className: 'empty-state-v3', style: noOptionStyle }, props.noOptionsMessage) :
                    props.noOptionsMessage;
                var noResultsTextElem;
                switch (typeof props.noResultsText) {
                    case 'string':
                        noResultsTextElem = React.createElement("div", { className: 'no-results-v3', style: noOptionStyle }, props.noResultsText);
                        break;
                    case 'function':
                        noResultsTextElem = props.noResultsText(_this.state.query);
                        break;
                    default:
                        noResultsTextElem = props.noResultsText;
                        break;
                }
                return (_this.state.query ? noResultsTextElem : noOptionsElem) ||
                    (noOptionsElem || React.createElement("div", { style: noOptionStyle }, "No results found"));
            };
            var Option = function (optionProps) {
                return React.createElement(ReactSelect3Components.Option, __assign({}, optionProps, { className: optionProps.data.className }));
            };
            var SingleValue = function (optionProps) {
                return React.createElement(ReactSelect3Components.SingleValue, __assign({}, optionProps, { className: optionProps.data.className }));
            };
            var classNamesV3 = namespacedClassnames('new-select', props.className, { small: _this.props.size === 'small' });
            var maybeMenuPortal = props.bringMenuToFront ? {
                menuPortalTarget: document.body,
                // tslint:disable-next-line: max-line-length
                menuShouldBlockScroll: props.menuShouldBlockScroll !== undefined ? props.menuShouldBlockScroll : true // Issue with menu repositioning on scroll so we need this - https://github.com/JedWatson/react-select/issues/4088
            } : {};
            return (React.createElement(ReactSelect3, __assign({}, defaultV3Props, maybeMenuPortal, { ref: _this.refSelectV3, value: !!valueV3 ? valueV3 : null, options: optionsV3, onChange: props.onChange, placeholder: props.placeholder, isDisabled: !!props.disabled, classNamePrefix: 'select-v3', className: classNamesV3, components: { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator, NoOptionsMessage: NoOptionsMessage, Option: Option, SingleValue: SingleValue, Menu: Menu }, styles: selectV3Styles(_this.props.size, _this.props.menuPlacement), 
                // blurInputOnSelect={true} - DONT PASS THIS as it conflicts with openMenuOnFocus
                isSearchable: props.searchable, onBlur: props.onBlur, onFocus: props.onFocus, onMenuOpen: props.onOpen, onMenuClose: props.onClose, onInputChange: _this.onInputChange, autoFocus: props.autoFocus, formatOptionLabel: _this.formatOptionLabel, menuPlacement: props.menuPlacement, menuShouldScrollIntoView: true, maxMenuHeight: 172, searchPromptText: props.searchPromptText, filterOption: _this.props.disableOptionFiltering ? function () { return true; } : undefined, menuShouldBlockScroll: false, "aria-label": props.ariaLabel })));
        };
        _this.shouldRenderWithTooltip = function (disabled) {
            return !!disabled && typeof disabled !== 'boolean';
        };
        return _this;
    }
    DeprecatedSelect.prototype.render = function () {
        var props = __assign(__assign(__assign({}, defaultProps), this.props), { 
            // This is needed when options are loaded async (like user search)
            // https://github.com/JedWatson/react-select/issues/761
            filterOption: this.props.disableOptionFiltering ? function () { return true; } : undefined });
        var isV3Enabled = false;
        try {
            isV3Enabled = !!this.props.useSelectV3;
        }
        catch (e) {
            console.info('using select v1');
        }
        var classNames = namespacedClassnames('select', props.className, { small: this.props.size });
        var deprecatedSelect = (React.createElement(ReactSelectAsync, __assign({}, props, { noResultsText: props.noResultsText || 'No results found', loadOptions: this.fakeLoadOptions, onSelectResetsInput: false, onBlurResetsInput: false, className: classNames, searchPromptText: props.searchPromptText, optionRenderer: this.optionRenderer, "aria-label": props.ariaLabel })));
        var selectComp = isV3Enabled ? this.renderV3() : deprecatedSelect;
        return this.shouldRenderWithTooltip(this.props.disabled) ? (React.createElement(Tooltip, { body: this.props.disabled, relativeToBody: true, className: 'disabled-select-tooltip', popperTargetClassName: props.popperTargetClassName }, selectComp)) : selectComp;
    };
    return DeprecatedSelect;
}(React.PureComponent));
export { DeprecatedSelect };
//# sourceMappingURL=select.js.map